export const colorsTheme = {
  white: '#FFFFFF',
  black: '#000000',
  danger: '#F2383A',

  'gradient-deg': '71deg',
  'gradient-primary': '#000',
  'gradient-secondary': '#FFFFFF',

  'primary-color': '#000',
  'secondary-color': '#000',
  'auxiliary-color': '#000',

  'bg-color': '#FFFFFF',
  'bg-secondary-color': '#FFFFFF',
  'bg-auxiliary-color': '#343A40',
  'bg-circle-color': '#FFFFFF',
  'bg-modal-color': '#343A40',

  'dark-color': '#3F3F3F',

  'text-primary': '#FFFFFF',
  'text-secondary': '#FFFFFF',
  'text-tertiary': '#FFFFFF',
  'text-gray': '#4F4F4F',
  
  'input-color': '#FFFFFF',
  'bg-input-color': '#FFFFFF',
  'info-color': '#6c757d',
  'disabled-color': '#6c757d',
  'card-color': '#495057',
  'modal-border-color': '#ADB5BD',
  'border-color': '#FFFFFF',
  'bg-login-color': '#9f1b1a',
  'bg-login-page-color': '#9f1b1a',

  'echeck-label-color': '#000',
  'echeck-border-color': '#D2D2D2',
  'echeck-text-color': '#000',
  'echeck-bar-color1': '#000',
  'echeck-bar-color2': '#000'
}